import { normalizeVariantId } from '../game/variants/index.js';
import type { ActiveSession, GameRecord, RecordedSeed } from './types.js';

// Stored history predates the `kozyol` → `telefon` rename. Records are mapped
// on read and never rewritten, so a rollback still finds the original ids.

function normalizeSeed(seed: RecordedSeed): RecordedSeed {
  const variant = normalizeVariantId(seed.variant);
  return variant === null || variant === seed.variant ? seed : { ...seed, variant };
}

export function normalizeSessionVariant(session: ActiveSession): ActiveSession {
  const seed = normalizeSeed(session.seed);
  return seed === session.seed ? session : { ...session, seed };
}

export function normalizeRecordVariant(record: GameRecord): GameRecord {
  const variant = normalizeVariantId(record.variant) ?? record.variant;
  const seed = normalizeSeed(record.seed);
  if (variant === record.variant && seed === record.seed) return record;
  return { ...record, variant, seed };
}
